const READONLY_FIELDS = [
    'created',
    'updated',
    'createdByUsername',
    'createdBy',
    'managedByUsername',
    'managedBy',
] as const;

export const stripReadonlyFields = <T extends Record<string, unknown>>(record: T): Partial<T> => {
    const result = {...record};
    for (const field of READONLY_FIELDS) {
        delete result[field as keyof T];
    }
    return result;
};
